import React, { useState, useEffect } from 'react';

import { apiGet } from '../config/apiClient';

export default function LocationSelector({ onChange, initialLocation }) {
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(initialLocation?.country || { id: '', name: '' });
  const [selectedRegion, setSelectedRegion] = useState(initialLocation?.region || { id: '', name: '' });
  const [selectedCity, setSelectedCity] = useState(initialLocation?.city || { id: '', name: '' });
  const [selectedNeighborhood, setSelectedNeighborhood] = useState(initialLocation?.neighborhood || { id: '', name: '' });

  useEffect(() => {
    apiGet('/locations/countries')
      .then(data => setCountries(Array.isArray(data) ? data : data.countries || []))
      .catch(error => console.error('Error fetching countries:', error));
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      apiGet(`/locations/regions?country_id=${selectedCountry.id}`)
        .then(data => setRegions(Array.isArray(data) ? data : data.regions || []))
        .catch(error => console.error('Error fetching regions:', error));
    } else {
      setRegions([]);
    }
  }, [selectedCountry.id]);

  useEffect(() => {
    if (selectedRegion.id) {
      apiGet(`/locations/cities?region_id=${selectedRegion.id}`)
        .then(data => setCities(Array.isArray(data) ? data : data.cities || []))
        .catch(error => console.error('Error fetching cities:', error));
    } else {
      setCities([]);
    }
  }, [selectedRegion.id]);

  useEffect(() => {
    if (selectedCity.id) {
      apiGet(`/locations/neighborhoods?city_id=${selectedCity.id}`)
        .then(data => setNeighborhoods(Array.isArray(data) ? data : data.neighborhoods || []))
        .catch(error => console.error('Error fetching neighborhoods:', error));
    } else {
      setNeighborhoods([]);
    }
  }, [selectedCity.id]);

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    const countryObj = countries.find(c => c.id.toString() === countryId) || { id: '', name: '' };
    setSelectedCountry({ id: countryId, name: countryObj.country_name || countryObj.name || '' });
    setSelectedRegion({ id: '', name: '' });
    setSelectedCity({ id: '', name: '' });
    setSelectedNeighborhood({ id: '', name: '' });
    setRegions([]);
    setCities([]);
    setNeighborhoods([]);
    onChange && onChange({ 
      country: { id: countryId, name: countryObj.country_name }, 
      region: { id: '', name: '' }, 
      city: { id: '', name: '' }, 
      neighborhood: { id: '', name: '' } 
    });
  };

  const handleRegionChange = (e) => {
    const regionId = e.target.value;
    const regionObj = regions.find(r => r.id.toString() === regionId) || { id: '', name: '' };
    setSelectedRegion({ id: regionId, name: regionObj.name });
    setSelectedCity({ id: '', name: '' });
    setSelectedNeighborhood({ id: '', name: '' });
    setCities([]);
    setNeighborhoods([]);
    onChange && onChange({ 
      country: selectedCountry, 
      region: { id: regionId, name: regionObj.name }, 
      city: { id: '', name: '' }, 
      neighborhood: { id: '', name: '' } 
    });
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    const cityObj = cities.find(c => c.id.toString() === cityId) || { id: '', name: '' };
    setSelectedCity({ id: cityId, name: cityObj.name });
    setSelectedNeighborhood({ id: '', name: '' });
    setNeighborhoods([]);
    onChange && onChange({ 
      country: selectedCountry, 
      region: selectedRegion, 
      city: { id: cityId, name: cityObj.name }, 
      neighborhood: { id: '', name: '' } 
    });
  };

  const handleNeighborhoodChange = (e) => {
    const neighborhoodId = e.target.value;
    const neighborhoodObj = neighborhoods.find(n => n.id.toString() === neighborhoodId) || { id: '', name: '' };
    setSelectedNeighborhood({ id: neighborhoodId, name: neighborhoodObj.name });
    onChange && onChange({ 
      country: selectedCountry, 
      region: selectedRegion, 
      city: selectedCity, 
      neighborhood: { id: neighborhoodId, name: neighborhoodObj.name } 
    });
  };

  return (
    <div className="flex flex-wrap gap-4 items-center justify-center py-4">
      {/* Country */}
      <select value={selectedCountry.id} onChange={handleCountryChange} className="border rounded px-3 py-2">
        <option value="">Select Country</option>
        {countries.map((c) => (
          <option key={c.id} value={c.id}>{c.country_name || c.name}</option>
        ))}
      </select>
      {/* Region */}
      <select value={selectedRegion.id} onChange={handleRegionChange} className="border rounded px-3 py-2" disabled={!selectedCountry.id || regions.length === 0}>
        <option value="">Select Region</option>
        {regions.map((r) => (
          <option key={r.id} value={r.id}>{r.name}</option>
        ))}
      </select>
      {/* City */}
      <select value={selectedCity.id} onChange={handleCityChange} className="border rounded px-3 py-2" disabled={!selectedRegion.id || cities.length === 0}>
        <option value="">Select City</option>
        {cities.map((ct) => (
          <option key={ct.id} value={ct.id}>{ct.name}</option>
        ))}
      </select>
      {/* Neighborhood */}
      <select value={selectedNeighborhood.id} onChange={handleNeighborhoodChange} className="border rounded px-3 py-2" disabled={!selectedCity.id || neighborhoods.length === 0}>
        <option value="">Select Neighborhood</option>
        {neighborhoods.map((n) => (
          <option key={n.id} value={n.id}>{n.name}</option>
        ))}
      </select>
    </div>
  );
} 